// import RoutingController from './controllers/routing';
import AnimationController from './controllers/animation';
import CursorController from './controllers/cursor';
import HeightController from './controllers/height';
import HubspotController from './controllers/hubspot';
import ModalController from './controllers/modal';
import ResizeController from './controllers/resize';
import ScrollController from './controllers/scroll';
import SectionController from './controllers/section';
import SkrolliteController from './controllers/skrollite';

import Platform from './constants/platform';

import { isIE } from './helpers';

class App {

	el = {};

	controllers = {
		animation: null,
		resize: null
	};

	flags = {
		isPageIn: false,
		isIframe: false
	};

	constructor() {

		this.el = {
			main: document.body.querySelector('main')
		};

		this.flags.isIframe = window.location.pathname.includes('styleguide/iframe');

		if (isIE()) {
			document.body.classList.add('is-ie');
		}

		this.#addEventListeners();
	}

	// initialize controllers

	#configureControllers = () => {

		// cursor tracking
		CursorController.initialize();

		// form integration
		HubspotController.initialize();

		// monitoring browser size and throttling events
		ResizeController.initialize();

		// maintaining viewport height for smooth scrolling
		HeightController.initialize();

		// smooth scrolling
		ScrollController.initialize(this.el.main, ['main > *'], false);
		this.checkResizeRender();

		// scroll-triggered animations
		SkrolliteController.initialize();

		// initialized without routing (this site is not a SPA)
		SectionController.initializeGlobals();
		SectionController.initialize();
		ModalController.initialize();

		/*

		// configure SPA routing controller

		RoutingController.overrideAnchors();
		RoutingController.start({
			'/': () => this.open('home')
			'/:page': (page) => this.open(page),
			'/page/:a/?:b': (a, b) => console.log(a, b)
		});

		*/

		AnimationController.start();
	}

	// page in / out controls

	pageIn() {
		if (!this.flags.isPageIn) {
			this.flags.isPageIn = true;

			document.body.classList.add('is-page-in');

			// observe current page sections for resizing

			ResizeController.observeSections(document.body.querySelectorAll('main > *'));

			// update scrolling settings to page configuration

			ScrollController.stickyTop = document.querySelector('main').dataset.stickyTop || 0;
			ScrollController.stickyOffset = document.querySelector('main').dataset.stickyOffset || 0;
			ScrollController.pageIn();

			// activate skrollite for this page

			SkrolliteController.pageIn();
		}
	}

	pageOut() {
		document.body.classList.remove('is-page-in');
	}

	// open new SPA page

	open() {
		// removed due to site not being SPA
	}

	// controller listeners

	#addControllerListeners = () => {
		this.controllers.animation = AnimationController.set({
			update: this.#onAnimationUpdate,
			render: this.#onAnimationRender
		});

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});

		ResizeController.measure();
	}

	// controller methods

	#onAnimationUpdate = () => {
		ScrollController.update();
		return true;
	}

	#onAnimationRender = () => {
		ScrollController.render();
	}

	#onResizeUpdate = () => {
		ScrollController.resizeUpdate();
		return true;
	}

	#onResizeRender = () => {
		this.checkResizeRender();
	}

	checkResizeRender() {
		let isChanged = false;

		if (ResizeController.platform === Platform.DESKTOP) {
			if (!ScrollController.isSmoothScrolling) {
				ScrollController.enableSmoothScrolling();
				isChanged = true;
			}
		} else {
			if (ScrollController.isSmoothScrolling) {
				ScrollController.disableSmoothScrolling();
				isChanged = true;
			}
		}

		if (!isChanged) {
			ScrollController.resizeRender();
		}
	}

	// event listeners

	#addEventListeners = () => {
		document.addEventListener('DOMContentLoaded', this.#onDOMContentLoaded);
		window.addEventListener('load', this.#onWindowLoaded);
	}

	// event listener methods

	#onDOMContentLoaded = () => {
		if (!this.flags.isIframe) {
			this.#configureControllers();
			this.#addControllerListeners();
		}
	};

	#onWindowLoaded = () => {
		this.pageIn();
	};

}

export default new App();
